module.exports = __webpack_public_path__ + "img/zd-top-4.4ccea0ac.svg";